import React from "react";
import "./SpotifyForArtists.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaSpotify } from "react-icons/fa";
import { Helmet } from 'react-helmet';
const SpotifyForArtists = () => {

  const steps = [
    "Create your FTTunes account",
    "Upload music & artwork",
    "Deliver music to Spotify",
    "Claim Spotify for Artists",
    "Customize your profile",
    "Track analytics & playlists"
  ];


return (
<>
  <Helmet>

    <title>
      Get a Verified Artist Profile on Spotify with Blue Tick | FT Tunes
    </title>

    <meta
      name="description"
      content="Get your Spotify artist profile verified with a blue tick through FT Tunes. Build credibility, access Spotify for Artists, and grow your music brand with ease. Fast and reliable service."
    />

    <meta
      name="keywords"
      content="Spotify verification, Spotify blue tick, verified artist Spotify, Spotify for Artists, music distribution India, FT Tunes, artist verification service, Spotify artist profile, blue tick Spotify India"
    />

    <meta name="robots" content="index, follow" />
    <meta name="author" content="FT Tunes" />

    {/* Open Graph */}
    <meta
      property="og:title"
      content="Get a Verified Artist Profile on Spotify with Blue Tick | FT Tunes"
    />

    <meta
      property="og:description"
      content="Apply for Spotify artist verification and get your blue tick with FT Tunes. Increase credibility and unlock powerful tools on Spotify."
    />

    <meta property="og:type" content="website" />

    <meta
      property="og:url"
      content="https://www.fttunes.com/get-verified-on-spotify"
    />

  </Helmet>

    <div className="spotify-page">

      {/* HERO */}
      <section className="spotify-hero">
        <Container>
          <img src="/Images/spotify-verified-artist.png" alt="" />

          <h1>
            Spotify for Artists: <br/> Get Verified

          </h1>

          <p>
            Release music worldwide, verify your artist profile and
            grow your audience using FTTunes music distribution.
          </p>

          <Button
            className="gradient-btn"
            href="https://dashboard.fttunes.com/register.php"
            target="_blank"
            rel="noopener noreferrer"
          >
            Start Releasing Music
          </Button>
        </Container>

        <div className="hero-glow"></div>
      </section>

      {/* IMAGE SECTION */}
      <section className="spotify-showcase">
        <Container>
          <Row className="align-items-center">

            <Col md={6}>
              <h2>Take Control Of Your Spotify Presence</h2>
              <p>
                Manage releases, understand listeners, pitch playlists
                and build your brand with powerful artist tools.
              </p>

          <Button
            as="a"
            className="outline-btn"
            href="https://dashboard.fttunes.com/register.php"
            target="_blank"
            rel="noopener noreferrer"
          >
            Distribute Now
          </Button>
            </Col>

            <Col md={6}>
            <img
              src="/Images/get-your-music-on-spotify.png"
              alt="Music Streaming"
              className="spotify-image"
            />
            </Col>

          </Row>
        </Container>
      </section>

      {/* STEPS */}
      <section className="spotify-steps">
        <Container>

          <h2 className="section-title">
            How It Works
          </h2>

          <Row>
            {steps.map((step,index)=>(
              <Col md={4} key={index}>
                <div className="step-card">
                  <span>0{index+1}</span>
                  <p>{step}</p>
                </div>
              </Col>
            ))}
          </Row>

        </Container>
      </section>

      {/* BENEFITS GRID */}
      <section className="spotify-benefits">
        <Container>

          <h2 className="section-title">
            Built For Independent Artists
          </h2>

          <Row>

            <Col md={3}>
              <div className="benefit-card">
                <h5>Global Distribution</h5>
                <p>Reach Spotify listeners worldwide instantly.</p>
              </div>
            </Col>

            <Col md={3}>
              <div className="benefit-card">
                <h5>100% Ownership</h5>
                <p>You keep full rights to your music.</p>
              </div>
            </Col>

            <Col md={3}>
              <div className="benefit-card">
                <h5>Real Analytics</h5>
                <p>Track fans, streams & growth in real time.</p>
              </div>
            </Col>

            <Col md={3}>
              <div className="benefit-card">
                <h5>Playlist Pitching</h5>
                <p>Submit songs to Spotify editorial playlists.</p>
              </div>
            </Col>

          </Row>

        </Container>
      </section>

      {/* CTA */}
      <section className="spotify-cta">
        <Container>
          <h2>Start Growing On Spotify Today</h2>
          <Button className="gradient-btn big">
            Upload Your Music
          </Button>
        </Container>
      </section>

    </div>
        </>
  );
};

export default SpotifyForArtists;